/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useEffect, useState } from 'react';

import * as Styled from './styled';

const DROPDOWN_WIDTH = 200;

export default function SubDropdown({ children, ...props }) {
  const [wrapperRef, setWrapperRef] = useState(null);
  const [verticalAlignment, setVerticalAlignment] = useState('right');
  const [horizontalAlignment, setHorizontalAlignment] = useState('top');

  useEffect(() => {
    if (wrapperRef) {
      const { right: parentPositionRight, bottom: parentPositionBottom } = wrapperRef
        .closest('[data-dropdown]')
        .getBoundingClientRect();

      if (document.body.offsetWidth - parentPositionRight > DROPDOWN_WIDTH) {
        setVerticalAlignment('left');
      }

      if (parentPositionBottom + wrapperRef.offsetHeight > document.body.offsetHeight) {
        setHorizontalAlignment('bottom');
      }
    }
  }, [wrapperRef]);

  return (
    <Styled.SubDropdown
      // @ts-expect-error TS2769
      $verticalAlignment={verticalAlignment}
      $horizontalAlignment={horizontalAlignment}
      ref={setWrapperRef}
      role="menu"
      {...props}
    >
      {children}
    </Styled.SubDropdown>
  );
}
